import React, {useEffect} from 'react';
import {useMsal} from '@azure/msal-react';
import {loginRequest} from '../authConfig';
import {Container, Row, Col, Card, Spinner} from 'react-bootstrap';

const AutoRedirectSignIn: React.FC = () => {
  const {instance} = useMsal();

  useEffect(() => {
    // Automatically redirect to sign in
    const initiateLogin = async () => {
      try {
        await instance.loginRedirect(loginRequest);
      } catch (error) {
        console.error('Login redirect failed:', error);
      }
    };

    // Small delay to ensure MSAL is fully initialized
    const timeoutId = setTimeout(initiateLogin, 500);

    return () => clearTimeout(timeoutId);
  }, [instance]);

  return (
    <Container className='mt-4'>
      <Row className='justify-content-center'>
        <Col md={6}>
          <Card className='text-center'>
            <Card.Body>
              <div className='d-flex justify-content-center mb-3'>
                <Spinner animation='border' role='status' variant='primary'>
                  <span className='visually-hidden'>Loading...</span>
                </Spinner>
              </div>
              <Card.Title>Signing you in...</Card.Title>
              <Card.Text>
                You will be redirected to Microsoft's sign-in page
                automatically.
              </Card.Text>
              <small className='text-muted'>
                If you are not redirected automatically, please check your
                browser settings.
              </small>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default AutoRedirectSignIn;
